import { type GasPayload } from '@atlaskit/analytics-gas-types';

import { PrimaryProductKeys } from '../../../constants/primary-product-keys';
import { getWordCount } from '../get-word-count';

export const getAdvancedSearchActionSubjectId = (primaryProduct: string): string =>
	primaryProduct === PrimaryProductKeys.Jira
		? 'jiraAdvancedIssueSearch'
		: `${primaryProduct.toLowerCase()}AdvancedSearchLink`;

/** Builds the event shared by every Quick Find search submission path. */
export const onAdvancedSearchLinkSelected = ({
	attributes,
	nonPrivacySafeAttributes,
	actionSubjectId,
	query,
	intent,
	isLoading,
	cohort,
}: {
	attributes: Record<string, unknown>;
	nonPrivacySafeAttributes: Record<string, unknown>;
	actionSubjectId: string;
	query: string;
	intent?: { mode: string; modelId?: string; patternType?: string } | null;
	isLoading?: boolean;
	cohort?: string;
}): GasPayload => ({
	eventType: 'track',
	action: 'selected',
	actionSubject: 'advancedSearchLink',
	actionSubjectId,
	attributes: {
		...attributes,
		wordCount: getWordCount(query),
		...(intent !== undefined && {
			queryClassification: intent?.mode,
			modelId: intent?.modelId,
			patternType: intent?.patternType,
		}),
		...(isLoading !== undefined && { isLoading }),
		...(cohort !== undefined && { cohort }),
	},
	nonPrivacySafeAttributes,
});
